import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const GoogleAnalyticsIntegrationSchema = z.object({
  id: z.string(),
  name: z.string(),
  accountId: z.string(),
  propertyId: z.number(),
  isRefreshTokenValid: z.boolean(),
  usingInCampaigns: z.boolean().optional(),
  userUpdatedAt: z.string().nullish(), //.nullable(),
  userUpdatedId: z.coerce.string().nullish(), //.nullable(),
  usingInAccounts: z.boolean().nullish(), //.nullable(),
  expired: z.boolean().nullish(), //.nullable(),
});

export const GoogleAnalyticsResponseSchema = createResponseSchema(
  GoogleAnalyticsIntegrationSchema,
);

const GA4IntegrationOauthUpdateItem = z.object({
  url: z.string(),
});

export const GA4IntegrationOauthUpdateResponseSchema = z.object({
  data: z.object({
    items: z.array(GA4IntegrationOauthUpdateItem),
  }),
});

export const GA4IntegrationOauthCreateRequestSchema = z.object({
  name: z.string(),
  accountId: z.string(),
  propertyId: z.string(),
});

export const GA4IntegrationCreateRequestSchema = z.object({
  state: z.string(),
  code: z.string(),
});

export const GA4IntegrationCreateResponseSchema = createResponseSchema(
  z.object({
    id: z.string(),
    name: z.string(),
    accountId: z.string(),
    propertyId: z.number(),
  }),
);

export const GA4IntegrationUpdateRequestSchema = z.object({
  name: z.string(),
});

export const GA4IntegrationOauthUrlQuerySchema = z.object({
  integrationId: z.string().nullable(),
});

export const GA4IntegrationOauthUrlResponseSchema = createResponseSchema(
  z.object({
    authorizationUrl: z.string(),
    oauthFlowId: z.string(),
  }),
);
export const GA4IntegrationCreateV3RequestSchema = z.object({
  oauthFlowId: z.string(),
  name: z.string(),
  accountId: z.string(),
  propertyId: z.number(),
});

export const GA4IntegrationOauthCallbackQuerySchema = z.object({
  oauthFlowId: z.string(),
  state: z.string(),
  code: z.string(),
  integrationId: z.string().nullable(),
});

export const GA4IntegrationOauthCallbackResponseSchema = createResponseSchema(
  z.object({
    reconnectState: z.string(),
  }),
);
